// apps/ecommerce/src/components/ai-chat/chat-fab.tsx
import { HiSparkles, HiX } from 'react-icons/hi';

interface ChatFABProps {
  isOpen: boolean;
  onClick: () => void;
}

export function ChatFAB({ isOpen, onClick }: ChatFABProps) {
  return (
    <button
      onClick={onClick}
      aria-label={isOpen ? 'Close chat' : 'Open chat'}
      className={[
        'fixed bottom-6 z-50',
        'btn btn-circle btn-primary shadow-lg',
        'transition-all duration-300 ease-in-out',
        isOpen ? 'right-[504px]' : 'right-6',
        // Mobile: always in corner
        'max-md:right-6',
      ].join(' ')}
    >
      {isOpen ? (
        <HiX className="w-5 h-5" />
      ) : (
        <HiSparkles className="w-5 h-5" />
      )}
    </button>
  );
}
